'use client'

import { ReactNode, useEffect } from 'react'

import { loadLocales } from '~/lib/gt/loader'

type LocaleLoaderProps = {
  locale: string
  children: ReactNode
}

export const LocaleLoader = ({ children, locale }: LocaleLoaderProps) => {
  useEffect(() => {
    loadLocales(locale)
  }, [locale])

  return children
}
